import { Civility } from './civility.enum';

export const CIVILITIES_OPTIONS = [
  { label: 'M', value: Civility.MALE },
  { label: 'Mme', value: Civility.FEMALE },
];
